import styled from 'styled-components/macro';

import { rem } from '@blueprint/ui';

import { List } from 'components/blueprint';
import { colors } from 'themes';

export const SuggestionList = styled(List)`
  && {
    position: absolute;
    padding-left: 0;
    margin: 0;
    border: ${rem(1)} solid ${colors.default};
    background-color: ${colors.white};
    width: 100%;
    display: none;
  }

  &.show {
    display: block;
  }
`;
